import axios from "../api/axios";
import { useState, useEffect } from "react";
import { IBuildingSelection, IBuilding } from "../models/dashboard";
import { addDays, getPreviousMonday } from "../utils/dateUtils";
import useAuth from "./UseAuth";
import moment from "moment";

const useDashboardSelection = (startDate : Date = moment(getPreviousMonday()).startOf('day').toDate(), 
                               endDate : Date =  addDays(getPreviousMonday(),7)) => {
    const DASHBOARD_URL = "/api/hbscan/dashboard/getscans";
    const BUILDING_URL =  "/api/hbscan/dashboard/GetBuildings";
    
    const [start, setStart] = useState<Date | null>(startDate);
    const [end, setEnd ]= useState<Date | null>(endDate); 
    
    const [buildingId, setBuildingId] = useState<number>(0);
    const [buildingSelections, setBuildingSelections] = useState<IBuildingSelection[]>();
    const [serverMessage, setServerMessage] = useState("");
    const {user} = useAuth();
    const [buildings,setBuildings] = useState<IBuilding[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    

    useEffect( () => {
        axios.get<IBuildingSelection[]>(BUILDING_URL,
            {headers: {Authorization : user ? user.guid : ""}}
        ).then( (response) => {
            const data = response.data;
            setBuildingSelections(data);
            setBuildingId(data[0].id);
        })
    },[user]);

    useEffect( () => {
        if(!buildingId && buildingId <= 0)
            return;
        setIsLoading(true);
        setServerMessage("");
        const startRequest = moment(start).startOf("day").toISOString();
        const endRequest = moment(end).endOf("day").toISOString();
        const route = `${DASHBOARD_URL}?buildingId=${buildingId}&start=${startRequest}&end=${endRequest}`;
        
        axios.get<IBuilding[]>(route,
            {headers: {Authorization : user ? user.guid : ""}}
        )
        .then( (response) => {
            const data = response.data;
            setBuildings(data);
            setIsLoading(false);
        })
        .catch( () => {
            setServerMessage("Server error");
            setIsLoading(false);
        })
    },[buildingId,user,start,end]);


    return {
        start,
        setStart,
        end,
        setEnd,
        buildingId,
        setBuildingId,
        buildings,
        buildingSelections,
        serverMessage,
        isLoading,
    };

}

export default useDashboardSelection;